module.exports = __webpack_public_path__ + "static/media/background-image_novo.4daef2fc.png";